import brand from '@helpers/brand';
import { getRetinaSrcs, imageUrl } from '@helpers/image';
import { Device, from } from '@helpers/media';
import SvgWheel from '@img/branding-graphics/curves-wheel.svg';
import { LinkButton } from '@stories/Components/Buttons/GeneralButton/Button';
import ScrollIndictator from '@stories/Components/General/ScrollIndictator/ScrollIndictator';
import SkipLink from '@stories/Components/General/SkipLink/SkipLink';
import { parseToHsl } from 'polished';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './HomepageHeroBanner.styles';
const HomepageHeroBanner = ({ initial = 0, ...props }) => {
    const initialId = props.items[initial].id;
    const [active, setActive] = React.useState(initialId);
    const [animate, setAnimate] = React.useState(false);
    React.useEffect(() => setAnimate(true), []);
    return (React.createElement(S.Container, { "data-variant": "dark" },
        React.createElement(SkipLink, null),
        props.items.map((item, i) => (React.createElement(React.Fragment, { key: `${item.id}-image` }, item.image ? (renderImage(item.image, item.id === active, i)) : (React.createElement(S.FallbackIcon, { "data-active": item.id === active, style: {
                '--highlightColour': brand.tertiary[item.highlightColour],
            } },
            React.createElement(SvgWheel, null)))))),
        React.createElement(S.Inner, null,
            renderContent(props.items[initial], true),
            props.items.map((item, i) => (React.createElement(React.Fragment, null, i === initial ? null : renderContent(item, false)))),
            React.createElement(S.TabsWrapper, null,
                props.items.map((item) => (React.createElement(FocusRing, { key: `${item.id}-tab`, focusRingClass: "focus-ring" },
                    React.createElement(S.TabButton, { onClick: () => setActive(item.id), "data-active": item.id === active, style: {
                            '--highlightColour': brand.tertiary[item.highlightColour],
                        } }, item.tabLabel ?? item.title)))),
                React.createElement(ScrollIndictator, null)))));
    function renderImage(image, active, index) {
        return (React.createElement("picture", null,
            React.createElement("source", { media: from(Device.ActualDesktop + 1), srcSet: getRetinaSrcs(image, 2560, 1440).join(',') }),
            React.createElement("source", { media: from(Device.DesktopLarge), srcSet: getRetinaSrcs(image, 1920, 1080).join(',') }),
            React.createElement("source", { media: from(Device.Desktop), srcSet: getRetinaSrcs(image, 1600, 1200).join(',') }),
            React.createElement("source", { media: from(Device.TabletLarge), srcSet: getRetinaSrcs(image, 1366, 768).join(',') }),
            React.createElement("source", { media: from(Device.Tablet), srcSet: getRetinaSrcs(image, 1024, 768).join(',') }),
            React.createElement("source", { media: from(Device.MobileLarge), srcSet: getRetinaSrcs(image, 768, 1024).join(',') }),
            React.createElement(S.Image, { src: imageUrl(image, { width: 479, height: 989 }), srcSet: getRetinaSrcs(image, 479, 989).join(','), alt: image.altText, role: !image.altText ? 'presentation' : undefined, "data-active": active, loading: index === 0 ? 'eager' : 'lazy' })));
    }
    function renderContent(item, isFirst) {
        const hsl = parseToHsl(brand.tertiary[item.highlightColour]);
        const hslString = `${hsl.hue} ${hsl.saturation * 100}% ${hsl.lightness * 100}%`;
        return (React.createElement(React.Fragment, { key: `${item.id}-content` },
            React.createElement(S.ContentWrapper, { "data-active": item.id === active, "data-animate": item.id === active && animate, style: {
                    '--highlightColour': brand.tertiary[item.highlightColour],
                } },
                React.createElement(S.Title, { as: isFirst ? 'h1' : 'h2' }, item.title),
                React.createElement(S.Subtitle, null, item.subtitle),
                item.cta && (React.createElement(LinkButton, { branding: "outline", href: item.cta.url, target: item.cta.target, title: item.cta.text ?? `Discover ${item.tabLabel ?? item.title}`, tabIndex: item.id !== active ? -1 : undefined }))),
            React.createElement(S.BeamWrapper, { "data-active": item.id === active, "data-animate": item.id === active && animate, style: {
                    '--highlightColour': hslString,
                } },
                React.createElement(S.LightBeam, null))));
    }
};
export default HomepageHeroBanner;
